module.exports = __webpack_public_path__ + "static/img/h2-11.8e46914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-11.png
// module id = fg0V
// module chunks = 1